import React from 'react'
import { Box, Typography } from '@the-platform-group/component-library'
import { getProfileSummary } from '../../utils'

const ProfileSummary = ({ person }) => {
  const summary = getProfileSummary(person)

  if (!summary) {
    return null
  }

  return (
    <Box>
      <Typography variant="body2" fontWeight="medium">
        {summary.fullName}
      </Typography>
      {summary.jobTitle && (
        <Typography variant="body2" color="text.secondary">
          {summary.jobTitle}
        </Typography>
      )}
      {summary.organizationName && (
        <Typography variant="body2" color="text.secondary">
          {summary.organizationName}
        </Typography>
      )}
    </Box>
  )
}

export default ProfileSummary
